module.exports = __webpack_public_path__ + "img/logo.1f59fbd1.png";